import { Navigate, generatePath, useParams } from "react-router";
import { SURVEY_PUBLIC_PAGE_ROUTE } from "@/shared/utils";

export default function SroiSurveyRedirect() {
  const { token = "" } = useParams<{ token: string }>();
  return <Navigate to={generatePath(SURVEY_PUBLIC_PAGE_ROUTE, { token })} replace />;
}
